<template>
      <div
        class="flex items-center justify-center h-14 w-14 text-white rounded-lg shrink-0 transition-all snap-center"
        :class="active ? 'bg-yellow-400 transform scale-125' : 'bg-red-700'"
        @click="$emit('yearClicked', year)">

        <div class="text-center">
          <p class="font-bold text-lg">{{ year }}</p>
          <p class="text-xs">سال</p>
        </div>

      </div>
</template>

<script>
export default {
  name: "YearViewer",
  emits: ["yearClicked"],
  props: ["year", "active"],
};
</script>
